// extracted by mini-css-extract-plugin
export default {"drawer":"DrawOptions_drawer__KFAgk","title":"DrawOptions_title__7f8Mx"};